import { useRef, useState, useEffect, useContext } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import * as React from "react";
import { DashboardContext } from "states/DashboardContext";
import CensusService from "../../../_services/Census/CensusService";
import CensusIndicatorDropDown from "./CensusIndicatorDropDown";
import CensusAreaDropDown from "./CensusAreaDropDown";
import CensusYearsDropDown from "./CensusYearsDropDown";

const censusService = CensusService();

const CensusExploreDropDownGroup = () => {
  const {
    dataSourceState,
    censusMapDataState,
    filterDataState,
    censusIndicatorNameState,
    censusSubGroupNameState,
    censusIsDefaultDataState,
    languageState,
    censusSelectedIndicatorState,
    loadingState,
    sectorState,
    subsectorState,
    indicatorState,
    subgroupState,
    selectedYearState,
    censusSelectedAreasState,
  } = useContext(DashboardContext);

  const [dataSource, setDatasource] = dataSourceState;
  const [censusMapData, setCensusMapData] = censusMapDataState;
  const [censusIndicatorName, setCensusIndicatorName] =
    censusIndicatorNameState;
  const [censusSubGroupName, setCensusSubGroupName] = censusSubGroupNameState;
  const [censusIsDefaultData, setCensusIsDefaultData] =
    censusIsDefaultDataState;
  const [filterData, setFilterData] = filterDataState;
  const [language] = languageState;
  const [censusSelectedIndicator, setCensusSelectedIndicator] =
    censusSelectedIndicatorState;
  const [indicator, setIndicator] = indicatorState;
  const [subgroup, setSubgroup] = subgroupState;
  const [selectedYear, setSelectedYear] = selectedYearState;
  const [censusSelectedAreas, setCensusSelectedAreas] =
    censusSelectedAreasState;
  // component state
  const [expandedSectors, setExpandedSectors] = useState(new Set());
  const [indicatorsI, setIndicatorsI] = useState([]);
  const [selectdSubSectorKey, setSelectedSubSectorKey] = useState();
  const [selectdIndicatorKey, setSelectedIndicatorKey] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [censusYears, setCensusYears] = useState([]);

  //For Scrolling the selected values
  const indicatorsRef = useRef(null);
  const areasRef = useRef(null);
  const yearsRef = useRef(null);

  // State for each list's scroll position
  const [scrollState, setScrollState] = useState({
    indicators: { isAtStart: true, isAtEnd: false },
    areas: { isAtStart: true, isAtEnd: false },
    years: { isAtStart: true, isAtEnd: false },
  });

  const SCROLL_AMOUNT = 150; // Pixels to scroll per button click

  // Function to update scroll state for a given ref
  const updateScrollState = (ref, key) => {
    if (ref.current) {
      const { scrollLeft, scrollWidth, clientWidth } = ref.current;

      setScrollState((prev) => ({
        ...prev,
        [key]: {
          isAtStart: scrollLeft <= 0,
          isAtEnd: scrollLeft + clientWidth >= scrollWidth - 1, // Prevent premature hiding
          hasOverflow: scrollWidth > clientWidth, // ✅ True if scrolling is needed
        },
      }));
    }
  };

  // Scroll Left
  const handleScrollLeft = (ref, key) => {
    if (ref.current) {
      ref.current.scrollBy({ left: -SCROLL_AMOUNT, behavior: "smooth" });
      setTimeout(() => updateScrollState(ref, key), 300); // Ensure state updates after scrolling
    }
  };

  // Scroll Right
  const handleScrollRight = (ref, key) => {
    if (ref.current) {
      ref.current.scrollBy({ left: SCROLL_AMOUNT, behavior: "smooth" });
      setTimeout(() => updateScrollState(ref, key), 300);
    }
  };

  // Attach scroll event listeners to each list
  useEffect(() => {
    const refs = {
      indicators: indicatorsRef,
      areas: areasRef,
      years: yearsRef,
    };

    Object.entries(refs).forEach(([key, ref]) => {
      if (ref.current) {
        ref.current.addEventListener("scroll", () =>
          updateScrollState(ref, key)
        );
        updateScrollState(ref, key); // Initial check
      }
    });

    return () => {
      Object.values(refs).forEach((ref) => {
        if (ref.current)
          ref.current.removeEventListener("scroll", () =>
            updateScrollState(ref, key)
          );
      });
    };
  }, [indicator, censusSelectedAreas, selectedYear]); // Update when data changes

  useEffect(() => {
    updateScrollState(indicatorsRef, "indicators"); // Initial check
  }, [censusSelectedIndicator]); // ✅ Runs when the list updates

  //function to set the selected census years
  const handleChangeSelectingCensusYear = (year) => {
    setSelectedYear((prev) =>
      prev.some((y) => y.time_value === year.time_value)
        ? prev.filter((y) => y.time_value !== year.time_value)
        : [...prev, year]
    );
  };

  // function to set indicators
  function setIndicators(
    indicatorkey,
    subgroupkey,
    indicator_name,
    subgroup_name
  ) {
    setCensusSelectedIndicator((state) => {
      const existingIndicatorIndex = state.findIndex(
        (item) => item.indicatorkey === indicatorkey
      );

      if (existingIndicatorIndex !== -1) {
        // If the indicator exists, remove the existing subgroupkey
        const updatedIndicators = [...state];
        const existingSubgroupIndex =
          updatedIndicators[existingIndicatorIndex].subgroupkey.indexOf(
            subgroupkey
          );

        if (existingSubgroupIndex !== -1) {
          updatedIndicators[existingIndicatorIndex].subgroupkey.splice(
            existingSubgroupIndex,
            1
          );
        }

        if (existingSubgroupIndex === -1) {
          // If subgroupkey doesn't exist, add it to the list
          updatedIndicators[existingIndicatorIndex].subgroupkey.push(
            subgroupkey
          );
        }

        // If subgroupkey is empty after removal, remove the whole indicator
        if (
          updatedIndicators[existingIndicatorIndex].subgroupkey.length === 0
        ) {
          updatedIndicators.splice(existingIndicatorIndex, 1);
        }

        // if the selected indicator list is null, reset the map data
        setCensusMapData([]);

        return updatedIndicators;
      } else {
        // If the indicator does not exist, add a new one
        return [
          ...state,
          { indicatorkey: indicatorkey, subgroupkey: [subgroupkey] },
        ];
      }
    });
  }

  // style
  const listItemStyle = {
    backgroundColor: "#ffffff",
    borderRadius: "2px",
    marginBottom: "8px",
    paddingLeft: "16px",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    transition: "background-color 0.2s ease-in-out", // Add a smooth transition effect
    cursor: "pointer", // Show the pointer cursor on hover
  };

  const [anchorEls, setAnchorEls] = React.useState({
    indicatorPopover: null,
    areaPopover: null,
    yearPopover: null,
  });

  const handleClick = (event, popoverName) => {
    setAnchorEls({ ...anchorEls, [popoverName]: event.currentTarget });
  };

  const handleClose = (popoverName) => {
    setAnchorEls({ ...anchorEls, [popoverName]: null });
  };

  async function fetchIndicatorDataValue() {
    const response = await censusService.getIndicatorDataValue(
      censusSelectedIndicator[0].indicator_short_name
    );
  }
  return (
    <div>
      <div className="flex flex-row p-0 items-center">
        <div className="w-1/6 pb-0">
          <CensusIndicatorDropDown />
        </div>
        <div className="flex flex-row gap-2 w-5/6 justify-between items-center">
          <button
            style={{ p: 0 }}
            onClick={() => handleScrollLeft(indicatorsRef, "indicators")}
            disabled={scrollState.indicators.isAtStart}
            className={`transition-opacity ${
              scrollState.indicators.isAtStart
                ? "hidden opacity-50 cursor-not-allowed"
                : "opacity-100"
            }`}
          >
            <ChevronLeftIcon className="text-gray-700 hover:text-black transition-all duration-200" />
          </button>

          <div
            ref={indicatorsRef}
            className="flex flex-row gap-2 overflow-hidden scrollbar-hide"
            style={{
              fontSize: "14px",
              scrollBehavior: "smooth",
              whiteSpace: "nowrap",
              maxWidth: "90%",
              display: "flex",
            }}
          >
            {censusSelectedIndicator.map((item) => {
              const indicatorItem = indicator.find(
                (i) => i.indicatorkey === item.indicatorkey
              );
              const indicatorName =
                indicatorItem?.indicator_name ?? "Unknown Indicator";

              return item.subgroupkey.map((subgroupKey, index) => {
                const subgroupItem = subgroup.find(
                  (s) => s.subgroupkey === subgroupKey
                );
                const subgroupName = subgroupItem
                  ? subgroupItem.subgroup_name
                  : "";

                return (
                  <div
                    key={`${item.indicatorkey}-${subgroupKey}`}
                    className="flex flex-row items-center bg-gray-100 border rounded-lg px-3 py-0 shadow-sm m-1"
                  >
                    <p className="font-small">{`${indicatorName} (${subgroupName})`}</p>
                    <CloseIcon
                      fontSize="small"
                      className="text-gray-600 cursor-pointer ml-2 hover:text-red-500 transition-all"
                      onClick={() =>
                        setIndicators(item.indicatorkey, subgroupKey)
                      }
                    />
                  </div>
                );
              });
            })}
          </div>

          {scrollState.indicators.hasOverflow &&
            !scrollState.indicators.isAtEnd && (
              <button
                onClick={() => handleScrollRight(indicatorsRef, "indicators")}
                className="opacity-100 transition-opacity"
              >
                <ChevronRightIcon className="text-gray-700 hover:text-black transition-all duration-200" />
              </button>
            )}
        </div>
      </div>
      {/* Areas Section */}
      <div className="flex flex-row p-0 items-center ">
        <div className="w-1/6 pb-1">
          <CensusAreaDropDown />
        </div>

        <div className="flex flex-row gap-2 w-5/6 justify-between">
          <button
            onClick={() => handleScrollLeft(areasRef, "areas")}
            disabled={scrollState.areas.isAtStart}
            className={`transition-opacity ${
              scrollState.areas.isAtStart
                ? "hidden opacity-50 cursor-not-allowed"
                : "opacity-100"
            }`}
          >
            <ChevronLeftIcon className="text-gray-700 hover:text-black transition-all duration-200" />
          </button>

          <div
            ref={areasRef}
            className="flex flex-row gap-2 overflow-hidden scrollbar-hide"
            style={{
              fontSize: "14px",
              scrollBehavior: "smooth",
              whiteSpace: "nowrap",
              maxWidth: "100%",
              display: "flex",
            }}
          >
            {censusSelectedAreas.map((item, index) => (
              <div
                key={index}
                className="flex flex-row items-center bg-gray-100 border rounded-lg px-3 py-0 shadow-sm"
              >
                <p className="font-small">{item.area_name}</p>
                <CloseIcon
                  fontSize="small"
                  onClick={() =>
                    setCensusSelectedAreas((prev) =>
                      prev.filter((area) => area.area_name !== item.area_name)
                    )
                  }
                  className="text-gray-600 cursor-pointer ml-2 hover:text-red-500 transition-all"
                />
              </div>
            ))}
          </div>

          {scrollState.areas.hasOverflow && !scrollState.areas.isAtEnd && (
            <button
              onClick={() => handleScrollRight(areasRef, "areas")}
              className="opacity-100 transition-opacity"
            >
              <ChevronRightIcon className="text-gray-700 hover:text-black transition-all duration-200" />
            </button>
          )}
        </div>
      </div>
      {/* Years Section */}
      <div className="flex flex-row p-0 items-center">
        <CensusYearsDropDown />

        <div className="flex flex-row gap-2 w-5/6 justify-between">
          <button
            onClick={() => handleScrollLeft(yearsRef, "years")}
            disabled={scrollState.years.isAtStart}
            className={`transition-opacity ${
              scrollState.years.isAtStart
                ? "hidden opacity-50 cursor-not-allowed"
                : "opacity-100"
            }`}
          >
            <ChevronLeftIcon className="text-gray-700 hover:text-black transition-all duration-200" />
          </button>

          <div
            ref={yearsRef}
            className="flex flex-row gap-2 overflow-hidden scrollbar-hide"
            style={{
              fontSize: "14px",
              scrollBehavior: "smooth",
              whiteSpace: "nowrap",
              maxWidth: "100%",
              display: "flex",
            }}
          >
            {selectedYear?.map((item, index) => (
              <div
                key={index}
                className="flex flex-row items-center bg-gray-100 border rounded-lg px-3 py-0 shadow-sm"
              >
                <p className="font-small">{item.time_value}</p>
                <CloseIcon
                  fontSize="small"
                  onClick={() =>
                    setSelectedYear((prev) =>
                      prev.filter((year) => year.time_value !== item.time_value)
                    )
                  }
                  className="text-gray-600 cursor-pointer ml-2 hover:text-red-500 transition-all"
                />
              </div>
            ))}
          </div>

          <button
            onClick={() => handleScrollRight(yearsRef, "years")}
            disabled={scrollState.years.isAtEnd}
            className={`transition-opacity ${
              scrollState.years.isAtEnd
                ? "hidden opacity-50 cursor-not-allowed"
                : "opacity-100"
            }`}
          >
            <ChevronRightIcon className="text-gray-700 hover:text-black transition-all duration-200" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CensusExploreDropDownGroup;
